export enum ProjectKind {
  Film,
  Series,
}
